import { useEffect as __mpUseEffect, useState as __mpUseState } from "react";
import React, { createElement, Component } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set browser tab title
const __MP_CONTROLS = [{
  "id": "searchSpeed",
  "label": "Search Speed",
  "kind": "select",
  "group": "Options",
  "default": "normal",
  "options": [{
    "value": "fast",
    "label": "Fast"
  }, {
    "value": "normal",
    "label": "Normal"
  }, {
    "value": "slow",
    "label": "Slow"
  }, {
    "value": "verySlow",
    "label": "Very Slow"
  }]
}];
function __mpIsValidControlValue(control, value) {
  if (control.kind === 'toggle') return typeof value === 'boolean';
  if (control.kind === 'number') {
    return typeof value === 'number' && Number.isFinite(value);
  }
  if (typeof value !== 'string' || value.length > 10000) return false;
  if (control.kind === 'select') {
    return control.options?.some(option => option.value === value) ?? false;
  }
  if (control.kind === 'color') {
    return /^#[0-9a-f]{6}$/i.test(value);
  }
  return true;
}
function __MPControlsRoot() {
  const [overrides, setOverrides] = __mpUseState({});
  __mpUseEffect(() => {
    const handleValues = event => {
      const nextValues = event.detail?.values;
      if (!nextValues || typeof nextValues !== 'object' || Array.isArray(nextValues)) {
        return;
      }
      const normalized = {};
      for (const control of __MP_CONTROLS) {
        const value = nextValues[control.id];
        if (__mpIsValidControlValue(control, value)) {
          normalized[control.id] = value;
        }
      }
      setOverrides(normalized);
    };
    const announceControls = () => {
      window.dispatchEvent(new CustomEvent('magicpatterns:controls-ready', {
        detail: {
          controls: __MP_CONTROLS
        }
      }));
    };
    window.addEventListener('magicpatterns:controls-values', handleValues);
    window.addEventListener('magicpatterns:controls-request', announceControls);
    announceControls();
    return () => {
      window.removeEventListener('magicpatterns:controls-values', handleValues);
      window.removeEventListener('magicpatterns:controls-request', announceControls);
    };
  }, []);
  return <App {...overrides} />;
}
document.title = 'Talab';
// Set a favicon: a circle using the Talab theme gradient with a white "T"
const faviconSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <defs>
    <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#4338CA"/>
      <stop offset="100%" stop-color="#A855F7"/>
    </linearGradient>
  </defs>
  <circle cx="32" cy="32" r="32" fill="url(#g)"/>
  <text x="32" y="44" font-family="Plus Jakarta Sans, Inter, sans-serif" font-size="40" font-weight="700" fill="#ffffff" text-anchor="middle">T</text>
</svg>`;
const setFavicon = () => {
  const existing = document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon']");
  existing.forEach(el => el.parentNode?.removeChild(el));
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/svg+xml';
  link.href = `data:image/svg+xml,${encodeURIComponent(faviconSvg)}`;
  document.head.appendChild(link);
};
setFavicon();
render(<__MPControlsRoot />, document.getElementById('root'));